export default {
    authenticationState: {
        __typename: 'AuthenticationState',
        authenticated: false,
        user: '',
        selectedAccount: '',
        accounts: []
    }
}